export default __webpack_public_path__ + "8a22a6ab5ec0c7cf11a80bd2dfcb8e4a.png";